(() => {
  let timer;
  function update() {
    clearTimeout(timer);
    const now = Date.now();
    let next = Infinity;
    document.querySelectorAll('[data-sale-window]').forEach(el => {
      const start = Number(el.dataset.saleStart);
      const end = Number(el.dataset.saleEnd);
      const valid = Number.isFinite(start) && Number.isFinite(end) && end > start;
      const phase = el.dataset.saleWindow;
      el.hidden = !valid || !(phase === 'before' ? now < start : phase === 'after' ? now >= end : now >= start && now < end);
      for (const boundary of [start, end]) if (boundary > now) next = Math.min(next, boundary - now);
    });
    if (Number.isFinite(next)) timer = setTimeout(update, Math.min(next + 50, 2147483647));
  }
  update();
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
})();
